import React from 'react';

import Certification from '../../images/Training.png';
import useStyles from './styles';

const TrainingIcon = ({ size }) => {
  const classes = useStyles({ size });
  return (
    <div className={classes.container}>
      <img src={Certification} alt="Certification icon" />
    </div>
  );
};

export default TrainingIcon;
